import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateTaskDto } from "@myapp/contract";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";
import { scheduleKeys } from "src/entities/schedule";

export function useCreateTask() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: CreateTaskDto) =>
      taskApi.create(dto).then((r) => r.data),
    onSuccess: () => {
      // `all`, not `lists()`: a created task can carry a technician and a start, which puts it on
      // the worker calendar too — and that reads `taskKeys.technicianTasks`, a sibling branch.
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
      queryClient.invalidateQueries({ queryKey: taskKeys.lists() });
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
    },
  });
}
